import { canDigitalizeActivities } from 'app/models/activityBatchConversion';
import { permissionsRol as contentRol } from 'app/policies/roles/contentsRol.access';
import { PATH_ACTIVITY_BATCH_CREATE, PATH_ACTIVITY_BATCH_DIGITALIZE, PATH_ACTIVITY_BATCH_REVIEW } from 'app/router/routesConfigActivityBatches';

// `path` es el patrón de la ruta (Routes.jsx pasa item.path), así que se compara contra la constante.
const GATED_PATHS = new Set([PATH_ACTIVITY_BATCH_CREATE, PATH_ACTIVITY_BATCH_DIGITALIZE, PATH_ACTIVITY_BATCH_REVIEW]);

// L1 (TAN-8123) el listado no aplica gating por rol: el acceso al banco ya está protegido por autenticación.
// TAN-8127 la creación (wizard) y TAN-8136 el panel de revisión requieren el flag
// showActivitiesBatchManagement y permiso de creación de contenidos. La digitalización pide además
// una cuenta de OneClick: ocultar la opción del desplegable no impide entrar por la URL.
export function activityBatches({ flags, path, user }) {
  const hasBatchAccess = !!flags?.showActivitiesBatchManagement && contentRol(user).create;

  if (path === PATH_ACTIVITY_BATCH_DIGITALIZE) {
    return hasBatchAccess && canDigitalizeActivities(user);
  }

  if (GATED_PATHS.has(path)) {
    return hasBatchAccess;
  }

  return true;
}
